import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=3f264820&"
import script from "./partnership.vue?vue&type=script&lang=js&"
export * from "./partnership.vue?vue&type=script&lang=js&"
import style0 from "./partnership.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports